// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2jbfM","label":"CategoryService_label__E1lj5","location":"CategoryService_location__1Wv0E"};